<template>
<div>
	<!-- new -->
	<div class="row mb-4">
		<!-- <div class="col-12">
				<h2>Overview</h2>
		</div> -->
		<!-- runningbot -->
		<div class="col-12 col-md-3">
			<div class="metric shadow-sm" v-on:click="goDashboard">
				<div class="background"></div>
				<div class="icon">
					<i class="fas fa-th-large"></i>
				</div>
				<div class="info">
					<div class="title">Dashboard</div>
					<div class="sub-title">Bot Count</div>
					<div class="value">{{ alivePeonCount | comma }}/{{ totalPeonCount | comma }}</div>
				</div>
			</div>
		</div>
		<!-- notification -->
		<div class="col-12 col-md-3">
			<div class="metric shadow-sm" v-on:click="goNotification">
				<div class="background"></div>
				<div class="icon">
					<i class="fas fa-flag-checkered"></i>
				</div>
				<div class="info">
					<div class="title">Notification</div>
					<div class="sub-title">Unconfirmed Messages</div>
					<div class="value">{{ totalUnconfirmedAlarmCount | comma }} <!-- /{{ totalUnconfirmedNotification }} --></div>
				</div>
			</div>
		</div>
		<!-- scripts -->
		<div class="col-12 col-md-3">
			<div class="metric shadow-sm" v-on:click="goScript">
				<div class="background"></div>
				<div class="icon">
					<i class="fas fa-magic"></i>
				</div>
				<div class="info">
					<div class="title">Script</div>
					<div class="sub-title">Sharable Scripts</div>
					<div class="value">{{ totalScripts | comma }}</div>
				</div>
			</div>
		</div>
		<!-- scripts -->
		<div class="col-12 col-md-3">
			<div class="metric shadow-sm" v-on:click="goStatistics">
				<div class="background"></div>
				<div class="icon">
					<i class="fas fa-chart-bar"></i>
				</div>
				<div class="info">
					<div class="title">Statistics</div>
					<div class="sub-title">Running time ({{ thisMonth }})</div>
					<div class="value">{{ totalRunningTime | comma }}</div>
				</div>
			</div>
		</div>
	</div>
	<!-- end new row -->	
</div>
</template>

<script>
export default {
	name: 'Summary',
	props: {
		msg: String
	},
	data() {
		return {
	// selectedPeon: '',
	// peonList: []
		}
	},
	methods: {
		goDashboard: function(event) {
			this.$router.push('/dashboard');
		},
		goNotification: function(event) {
			if(this.$route.path !== '/notification') this.$router.push('/notification');
		},
		goScript: function(event) {
			this.$router.push('/script');
		},
		goStatistics: function(event) {
			this.$router.push('/statistics');
		},
	},
	computed: {
		alivePeonCount() {
			var count = 0;

			this.$store.state.peonList.forEach(function(item, index, array) {
				if (item.status === 'Ready' || item.status === 'Running') {
					count++;
				}
			});

			return count;
		},
		totalPeonCount() {
			return this.$store.state.deviceIds == null ? 0 : this.$store.state.deviceIds.length;
		},
		// totalUnconfirmedNotification() {
		// 	return this.$store.state.totalUnconfirmedNotification;
		// },
		totalUnconfirmedAlarmCount(){
			return this.$store.getters.getTotalUnconfirmedAlarmCount ? this.$store.getters.getTotalUnconfirmedAlarmCount : 0;
		},
		totalUnconfirmedAlarm() {
			return this.$store.getters.getTotalUnconfirmedAlarm ? this.$store.getters.getTotalUnconfirmedAlarm : 0;
		},
		totalScripts() {
			return this.$store.state.scriptList == null ? 0 : this.$store.state.scriptList.length;
		},
		totalRunningTime() {
			return this.$store.state.totalRunningTime;
		},
		thisMonth() {
			var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

			return monthNames[new Date().getMonth()];
		}
	},
	filters: {
		comma(val) {
			return val ? String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
		}
	},
	created() {
		var that = this;
		this.$store.dispatch('retrievePeonList').then(() => {
			this.$store.dispatch('retrieveLatestData');

			// 이 값을 보여주는 것을 Statistics.vue에서 주석 처리 했기 때문에 반복 호출할 필요는 없음
			// this.statisticsTimer = setInterval(function() {
			// 		that.$store.dispatch('retrieveStatistics');
			// }, 30000);
			this.$store.dispatch('retrieveStatistics');  // 통계 요약 정보는 필요하니까..

			// this.timer = setInterval(function() {
			// 	this.$store.dispatch('retrieveLatestData').catch(message => {
			// 		if (message != null && message.response != null && message.response.status === 401) {
			// 			that.$router.push('/signin');
			// 		}
			// 	});
			// }.bind(this), 10000);

			// this.notificationTimer = setInterval(function() {
			// 	that.$store.dispatch('retrieveNotificationList', { 'baseTimestamp': '' });
			// }, 10000);

			// that.$store.state.peonList.forEach(function(item, index, array) {
			// 	that.$store.dispatch('retrieveNotification', {'tenantId': item.tenantId, 'deviceId': item.deviceId});
			// });
		}).catch(message => {
			if (message != null && message.response != null && message.response.status === 401) {
				that.$router.push('/signin');
			}
		});  //.bind(that);

		// summary에서 Script 개수를 보여주기 때문에 여기서 호출
		this.$store.dispatch('retrieveScriptList', 'all');
		this.$store.dispatch('retrieveTotalNotificationCount');
		console.log("aaaa");
	},
	beforeDestroy() {
		clearInterval(this.timer);
		clearInterval(this.notificationTimer);
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
